import { render } from "./AutoSystemClassificationResultsPage.vue?vue&type=template&id=0abb3d58&scoped=true&ts=true"
import script from "./AutoSystemClassificationResultsPage.vue?vue&type=script&lang=ts"
export * from "./AutoSystemClassificationResultsPage.vue?vue&type=script&lang=ts"

import "./AutoSystemClassificationResultsPage.vue?vue&type=style&index=0&id=0abb3d58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abb3d58"]])

export default __exports__